var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"max-width":"960px"}},[_c('v-row',[_c('v-col',{attrs:{"sm":"12","md":"5","lg":"5","xl":"3"}},[_c('HiperList')],1),_c('v-col',{attrs:{"sm":"12","md":"7","lg":"7","xl":"9"}},[_c('Note')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }